import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-white px-6 py-24 md:px-12 md:py-32"
    >
      <div className="mx-auto max-w-5xl">
        <p
          data-testid="neutrality-statement"
          className="font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl md:text-4xl"
        >
          The California Rental Experience Project does not advocate for landlords or
          tenants. We advocate for better understanding through research, transparency,
          and respectful dialogue.
        </p>

        <div className="mt-16 grid gap-10 border-t border-slate-200 pt-10 sm:grid-cols-3">
          <div className="sm:col-span-1">
            <div className="font-serif text-lg text-ink">
              California Rental Experience Project
            </div>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">
              An independent, nonpartisan housing research initiative.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-400">
              Explore
            </div>
            <div className="mt-3 flex flex-col gap-2 text-sm">
              <Link to="/principles" data-testid="footer-principles-link" className="text-slate-600 hover:text-cardinal">
                Our Principles
              </Link>
              <Link to="/data" data-testid="footer-data-link" className="text-slate-600 hover:text-cardinal">
                Live Data
              </Link>
              <Link to="/database" data-testid="footer-database-link" className="text-slate-600 hover:text-cardinal">
                Criteria Database
              </Link>
              <Link to="/status" data-testid="footer-status-link" className="text-slate-600 hover:text-cardinal">
                Submission Status
              </Link>
              <Link to="/methodology" data-testid="footer-methodology-link" className="text-slate-600 hover:text-cardinal">
                Methodology
              </Link>
              <Link to="/research-standards" data-testid="footer-research-standards-link" className="text-slate-600 hover:text-cardinal">
                Research Standards
              </Link>
              <Link to="/data-use" data-testid="footer-data-use-link" className="text-slate-600 hover:text-cardinal">
                How We Use Your Data
              </Link>
              <Link to="/about" data-testid="footer-about-link" className="text-slate-600 hover:text-cardinal">
                About the Project
              </Link>
              <Link to="/advisory" data-testid="footer-advisory-link" className="text-slate-600 hover:text-cardinal">
                Advisory Board
              </Link>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-400">
              Contact
            </div>
            <a
              data-testid="footer-contact-email"
              href="mailto:ray@proptekinc.com"
              className="mt-3 block text-sm text-slate-600 hover:text-cardinal"
            >
              ray@proptekinc.com
            </a>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="mt-6 block text-xs text-slate-300 hover:text-slate-500"
            >
              Researcher access
            </Link>
          </div>
        </div>

        <div
          data-testid="footer-disclaimer"
          className="mt-12 max-w-3xl border-t border-slate-200 pt-8 text-xs leading-relaxed text-slate-500"
        >
          The California Rental Experience Project is an independent research initiative. The
          experiences shared on this website represent the views of individual participants.
          Submission of a story does not imply verification of factual claims, endorsement by
          the Project, or legal conclusions. Published reports rely on aggregated, anonymized
          data unless explicit permission is provided.
        </div>

        <div className="mt-8 text-xs text-slate-400">
          © {new Date().getFullYear()} California Rental Experience Project. Individual
          experiences are kept private and are never published. Only aggregate, anonymous
          data is shared publicly.
        </div>
      </div>
    </footer>
  );
}
